import { Injectable } from '@angular/core';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { CircularRequest, StepDecision } from '../models/circular.model';
import { HttpClient } from '@angular/common/http';
//import { Observable } from 'rxjs';
//import { idLocale } from 'ngx-bootstrap';

@Injectable({ providedIn: 'root' })
export class CircularService {
    constructor(private http: HttpServices, private _http: HttpClient) {

    }
    submitEditedRequest(circularRequest: CircularRequest) {
        return this.http.post('Circulars/SubmitEditedRequest', circularRequest);
    }

    Add(circularRequest: CircularRequest) {
        return this.http.post('Circulars/Add', circularRequest);
    }
    getRequest(RequestId: string) {
        return this.http.get('Circulars/GetCircularRequest?RequestId=' + RequestId);
    }

    getPercentagesByCircularId(id: string) {
        return this.http.get('Circulars/GetCircularPercentagesBYCircularID?id=' + id);
    }
    getPercentages(id: string) {
        return this.http.get('Circulars/GetCircularPercentages?id=' + id);
    }

    GetPercentagesFiltered(circularId, directionId , SailingDate,ETA) {

      return this.http.get('Circulars/GetPercentagesFiltered?circularId=' + circularId + '&directionId=' + directionId+"&SailingDate="+SailingDate+"&ETA="+ETA);
  }
    GetPercentageByDirectionAndCircularId(circularId: number, directionId: number) {

        return this.http.get('Circulars/GetPercentageByDirectionAndCircularId?circularId=' + circularId + '&directionId=' + directionId);
    }
    GetPercentageByDirectionAndCircularIdWithDeleted(circularId: number, directionId: number) {

        return this.http.get('Circulars/GetPercentageByDirectionAndCircularIdWithDeleted?circularId=' + circularId + '&directionId=' + directionId);
    }
    GetPercentageByFromRegionIdandCircularID(regionID: number, circularId: number , SailingDate,ETA) {

        return this.http.get('Circulars/GetPercentageByFromRegionIdandCircularID?regionID=' + regionID + '&circularId=' + circularId+"&SailingDate="+SailingDate+"&ETA="+ETA);
    }
    GetPercentageByFromRegionId(FromRegionId: string) {
        return this.http.get('Circulars/GetPercentageByFromRegionId?FromRegionId=' + FromRegionId);
    }
    /*SubmitFirstDecision(CommitteeDecision: StepDecision) {
        return this.http.post('Circulars/SubmitFirstDecision', CommitteeDecision);
    }*/
    SubmitAdminDecision(data: StepDecision) {
        return this.http.post('Circulars/SubmitAdminDecision', data);
    }
    SubmitRequestorDecision(data: StepDecision) {
        return this.http.post('Circulars/SubmitRequestorDecision', data);
    }
    getFirstDecision(CircularRequestID) {
        return this.http.get('Circulars/GetCircularFixedRebateDecisions?CircularRequestID=' + CircularRequestID);
    }
    confirmShipPassing(circularRequest: CircularRequest) {
        return this.http.post('Circulars/ConfirmShipPassing', circularRequest);
    }
    refundCloseRequest(circularRequest: CircularRequest) {
        return this.http.post('Circulars/RefundCloseRequest', circularRequest);
    }
    cancelRequest(circularRequest: CircularRequest) {
        return this.http.post('Circulars/CancelRequest', circularRequest);
    }
    confirmCancelRequest(circularRequest: CircularRequest) {
        return this.http.post('Circulars/confirmCancelRequest', circularRequest);
    }
    rejectionNotification(data: StepDecision) {
        return this.http.post('Circulars/SubmitrejectionNotification', data);
    }
    getRelatedRequests(pIMONO: String, RequestId: String) {
        return this.http.get('Circulars/GetRelatedRequests?pIMONO=' + pIMONO + '&RequestId=' + RequestId);
    }

    GetValidRequests(pIMONO: String, agentEmail: String) {
        return this.http.get('Circulars/GetValidRequests?pIMONO=' + pIMONO + '&agentEmail=' + agentEmail);
    }
}
